var exports = {
  "kL": "xdbfd91f1--bcabd7--container",
  "sL": "xdbfd91f1--bcabd7--container--active",
  "nd": "xdbfd91f1--bcabd7--panel",
  "iE": "xdbfd91f1--bcabd7--wrapper",
  "HU": "xdbfd91f1--bcabd7--aside",
  "h_": "xdbfd91f1--bcabd7--description",
};

module.exports = exports;
